import { useRouter } from 'next/router'
import { FC, PropsWithChildren, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DEFAULT_LANGUAGE } from '@/locales/i18n'

const I18nProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isClient, setIsClient] = useState(false)
  const router = useRouter()
  const { i18n } = useTranslation()

  const language = useMemo(() => {
    return router.query?.lang && typeof router.query.lang === 'string'
      ? router.query.lang
      : DEFAULT_LANGUAGE
  }, [router.query.lang])

  if (!isClient) {
    i18n.changeLanguage(language)
  }

  useEffect(() => {
    i18n.changeLanguage(language)
    setIsClient(true)
  }, [language, i18n])

  return <>{children}</>
}

export default I18nProvider
